import {
  ACTION_APPLE_PAY_CANCEL_ORDER,
  ACTION_APPLE_PAY_SEND_PAYMENT_TOKEN,
  ACTION_APPLE_PAY_UPDATE_ORDER_SUMMARY,
  actions,
} from './actions/apple-pay'
import { mutations } from './mutations/apple-pay'
import { isEmpty, performValidation } from '../libs/apple-pay-helpers'
import { CATALOG_ID, LANG_ID, STORE_ID } from '@/scripts/constants/parameters'
import { ORDER_OK_VIEW } from '@/scripts/constants/pages'
import { ORDER_ID } from '../constants/parameters'

export const applePay = {
  namespaced: true,
  state: {
    // Here we describe the default strategy methods.
    strategy: {
      onSentToken: null,
      showNextPage: (errorview, successview, response, errormessage, commonParams) => {
        if (response === 0) {
          document.location.href =
            errorview + '?' + commonParams + '&applePayErrorMessage=' + errormessage
        } else {
          document.location.href = '/webapp/wcs/stores/servlet/' + successview + '?' + commonParams
        }
      },
      onCancelApplePay: (context) => {
        context.dispatch(ACTION_APPLE_PAY_CANCEL_ORDER)
      },
      onPaymentAuthorized: (context, payment, mq) => {
        context.dispatch(ACTION_APPLE_PAY_SEND_PAYMENT_TOKEN, { payment, mq })
      },
      onUpdateShippingAddressSuccess: (context, shippingContact) => {
        context.dispatch(ACTION_APPLE_PAY_UPDATE_ORDER_SUMMARY, { city: shippingContact.locality })
      },
      makeAddressFlag: (countryCode) => {
        return countryCode === 'CA' ? 'false' : 'true'
      },
      makePaymentRequestObject: null,
      extraApplePayParameterCreator: null,
    },
    loading: false,
    applePaySession: null,
    addressDebug: false,
    performValidation: true,
    countryCode: undefined,
    orderId: undefined,
    defaultShippingModeId: undefined,
    paymentRequest: null,
    shippingContactValidationRules: null,
    shippingAddressInitialValidationRules: null,
    shippingAddressFinalValidationRules: null,
    billingAddressValidationRules: null,
    zipcodePatternsMap: {
      us: '(\\d{5}([\\-]\\d{4})?)',
      ca: '[A-Za-z](\\s?)[0-9](\\s?)[A-Za-z](\\s?)[0-9](\\s?)[A-Za-z](\\s?)[0-9](\\s?)',
      cn: '(\\d{6}?)',
      pl: '(\\d{2}([\\-]\\d{3}))',
      dk: '(\\d{3,4})',
      ch: '^(?!(7563|8238|6911)).*(\\d{4})',
      tr: '^(?!99).*(\\d{5})',
      no: '(\\d{4})',
      se: '^\\d{5}|(\\d{3}[\\s|\\d{1}]\\d{2})',
      at: '(\\d{4})',
      be: '(\\d{4})',
      it: '^(?!(23030|22060)).*(\\d{5})',
      fr: '^(?!(97[1-8])).*^(?!(98[6-8])).*(\\d{5})',
      de: '^(?!(78266|27498)).*(^(\\d{4,5})$)',
      es: '^(?!52).*^(?!51).*^(?!35).*^(?!38).*(\\d{5})',
      gb: '^(?!BF1).*^(?!GY).*^(?!JE).*^(?!FO).*^(?!bf1).*^(?!gy).*^(?!je).*^(?!fo).*([A-Za-z0-9 ]{5,7})',
      nl: '([0-9][0-9][0-9][0-9][\\s]?[A-Za-z][A-Za-z])',
      ie: '(^([a-zA-Z0-9\\s]){7,8}$)',
      pt: '^(?!(9[1-9][0-9][0-9])).*(\\d{4})',
      fi: '^(?!22).*(\\d{5})',
      mx: '^(|[0-9_-]{5})$',
    },
    fromPageMark: '',
    errorView: 'ShopCardDisplayView',
    successView: ORDER_OK_VIEW,
    sendPaymentTokenResponseData: '',
  },
  getters: {
    isBillingContactValid:
      ({ billingAddressValidationRules }) =>
      (billingContact) => {
        return performValidation(billingContact, billingAddressValidationRules)
      },
    isFinalShippingAddressValid:
      ({ shippingAddressFinalValidationRules }, { isInitialShippingAddressValid }) =>
      (shippingContact) => {
        if (!isInitialShippingAddressValid(shippingContact)) {
          return false
        }

        return performValidation(shippingContact, shippingAddressFinalValidationRules)
      },
    isShippingContactValid:
      ({ shippingContactValidationRules }) =>
      (shippingContact) => {
        return performValidation(shippingContact, shippingContactValidationRules)
      },
    isInitialShippingAddressValid:
      ({ countryCode, shippingAddressInitialValidationRules }) =>
      (shippingContact) => {
        if (isEmpty(shippingContact)) {
          return false
        }

        if (shippingContact.countryCode.toLowerCase() === countryCode.toLowerCase()) {
          return performValidation(shippingContact, shippingAddressInitialValidationRules)
        }

        return false
      },
    commonParameters(
      { fromPageMark, orderId },
      getters,
      { storeConfig: { storeId, orderId: predefinedOrderId, catalogId, langId } }
    ) {
      let params = `${STORE_ID}=${storeId}&${CATALOG_ID}=${catalogId}&${LANG_ID}=${langId}`

      if (orderId) {
        params += `&${ORDER_ID}=${orderId}`
      } else if (predefinedOrderId) {
        params += `&${ORDER_ID}=${predefinedOrderId}`
      } else {
        // TODO: Remove direct dom manipulations once this value will be populated to store
        const orderIdInput = document.getElementById(ORDER_ID)
        if (orderIdInput) {
          params += `&${ORDER_ID}=${orderIdInput.value}`
        }
      }

      if (fromPageMark) {
        params += `&${fromPageMark}=true`
      }

      return params
    },
    selectedShippingModeIdParameter(state) {
      // TODO: Find this input on the webapp and get this data from vuex store, if possible
      const shipModeIdInput = document.querySelector('input[name=shipping]:checked')
      const shipModeId = shipModeIdInput ? shipModeIdInput.value : undefined
      return shipModeId ? shipModeId : state.defaultShippingModeId
    },
  },
  actions,
  mutations,
}
